// Arabic service pages content. Each key matches the English slug so
// hreflang pairs automatically ({en: /services/:slug, ar: /ar/services/:slug}).
// AI Lab lives at /ar/ai-lab. Enterprise Software and Web Design are not
// included in this batch — those AR routes will fall through to the
// English component until batch 3 supplies real Arabic copy.

export const SERVICES_AR = {
  "custom-software-development-company-in-oman": {
    slug: "custom-software-development-company-in-oman",
    navLabel: "تطوير برمجيات مخصصة",
    eyebrow: "الخدمات",
    h1: "تطوير برمجيات مخصصة في عُمان",
    meta: {
      title: "تطوير برمجيات مخصصة في عُمان",
      description: "برمجيات مخصصة من شركة مقرها عُمان. ويب، جوال، تكاملات، وذكاء اصطناعي، مصممة لمتطلبات قانون حماية البيانات.",
    },
    intro: "وفا سوليوشنز LLC شركة تقنية مقرها عُمان، والشريك التقني لمجموعة Altalib. نبني برمجيات مخصصة للشركات في عُمان والمنطقة. عندما لا يناسب الحل الجاهز طريقة عملكم فعليًا، نبني الحل الذي يناسبها — مصمم حول عمليتكم بدلًا من إجباركم على عملية غيركم.",
    sections: [
      {
        type: "block", heading: "متى يكون الحل المخصص هو الصحيح",
        bullets: [
          "عمليتكم هي ميزتكم التنافسية والبرمجيات الجاهزة تُسطّحها",
          "تدفعون لخمس أدوات لا تتواصل مع بعضها",
          "فريقكم يقضي ساعات أسبوعيًا في نقل البيانات يدويًا",
          "تكلفة التراخيص ترتفع مع كل موظف جديد",
          "تحتاجون العربية، أو شيئًا لا يقدّمه السوق المحلي",
        ],
      },
      { type: "callout", text: "سنخبركم أيهما ينطبق عليكم. إن كانت أداة جاهزة بتكلفة 200 ريال شهريًا تحل المشكلة، سنقول ذلك بدلًا من أخذ رسوم بناء غير ضرورية." },
      {
        type: "grid", heading: "ستة أشكال من البرمجيات المخصصة",
        items: [
          { title: "منصات ويب", desc: "بوابات، أدوات داخلية، ومنتجات عامة." },
          { title: "تطبيقات الجوال", desc: "iOS و Android من قاعدة كود واحدة." },
          { title: "طبقات التكامل", desc: "لنجعل الأنظمة التي تملكونها تتحدث مع بعضها." },
          { title: "واجهات برمجية", desc: "واجهات عامة وواجهات للشركاء، موثّقة وذات إصدارات." },
          { title: "الأتمتة", desc: "تدفقات عمل تُلغي عملًا يدويًا حقيقيًا — مع سجل تدقيق." },
          { title: "ترحيل الأنظمة", desc: "من نظام قديم إلى جديد، دون فقدان بيانات السنوات الماضية." },
        ],
      },
      {
        type: "stack", heading: "الحزمة التقنية",
        items: ["React", "Next.js", "TypeScript", "Tailwind", "React Native / Expo", "Python", "FastAPI", "Node", "MongoDB", "PostgreSQL", "Redis", "الحوسبة السحابية المُدارة", "Docker", "CI/CD"],
      },
      {
        type: "bullets", heading: "ما يأتي كمعيار قياسي",
        items: [
          "صلاحيات وصول قائمة على الأدوار",
          "سجلات تدقيق كاملة",
          "واجهة عربية وإنجليزية",
          "تصميم متجاوب على مختلف الأجهزة",
          "تقارير وتصدير إلى Excel",
          "نسخ احتياطي تلقائي",
          "مراقبة الأخطاء",
          "واجهة برمجية موثّقة",
        ],
      },
      { type: "process" },
      {
        type: "faq",
        items: [
          { q: "كم يستغرق مشروع مخصص عادةً؟", a: "أداة داخلية محددة تستغرق عادةً من ستة إلى عشرة أسابيع. منصة بتطبيقات جوال ولوحة تحكم من ثلاثة إلى ستة أشهر. نقسم كل مشروع إلى مراحل من أسبوعين، لتروا برمجيات تعمل كل أسبوعين." },
          { q: "كم تبلغ التكلفة؟", a: "أداة داخلية صغيرة تبدأ من آلاف الريالات القليلة. منصة بتطبيقات متعددة تصل إلى عشرات الآلاف. قبل التزامكم نرسل تفصيلًا مكتوبًا حسب الوحدة حتى لا تكون هناك مفاجآت." },
          { q: "هل نملك الكود؟", a: "نعم عند السداد النهائي. مكوّناتنا المُعادة الاستخدام تظل مرخصة لكم، وهو ما يُبقي السعر منخفضًا — لا تدفعون مقابل كتابة نفس اللبنات في كل مشروع." },
          { q: "هل يمكنكم تولّي نظام بناه فريق آخر؟", a: "نعم. نجري تدقيقًا لعشرة أيام عمل، ثم نقدّم توصية صادقة: إصلاح / إعادة بناء / ترك النظام كما هو. أحيانًا يكون الجواب أن النظام سليم ويحتاج فقط من يراقبه." },
          { q: "أين سيتم استضافته؟", a: "نناقش الخيارات معكم — التكلفة، الأداء، وأثر كل خيار على التزامات قانون حماية البيانات — ليكون الاختيار واعيًا، موثقًا، وقابلًا للتغيير إن سأل منظم أو عميل سؤالًا أصعب لاحقًا." },
          { q: "هل توقّعون اتفاقية سرية؟", a: "نعم، قبل أول محادثة تفصيلية." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "تطوير SaaS", desc: "منتجات متعددة المستأجرين مصممة للبيع.", to: "/ar/services/saas-development-company-in-oman" },
      { tag: "الخدمات", label: "دعم وصيانة التطبيقات", desc: "الاهتمام بما تملكونه بالفعل.", to: "/ar/services/application-support-maintenance-oman" },
      { tag: "الأعمال", label: "منصة التوصيل والخدمات اللوجستية", desc: "جاهزة للإطلاق في عُمان.", to: "/ar/work/delivery-logistics-platform" },
    ],
  },

  "saas-development-company-in-oman": {
    slug: "saas-development-company-in-oman",
    navLabel: "تطوير منتجات SaaS",
    eyebrow: "الخدمات",
    h1: "تطوير منتجات SaaS في عُمان",
    meta: {
      title: "تطوير منتجات SaaS في عُمان",
      description: "منصات SaaS من الشاشة الأولى إلى محرك الفوترة، مبنية للأسئلة التي سيطرحها عملاؤكم هنا حول البيانات.",
    },
    intro: "نبني منصات SaaS من الشاشة الأولى إلى محرك الفوترة. بنية متعددة المستأجرين، إدارة الاشتراكات، لوحات تحكم، تحليلات، ونشر سحابي — من شركة تفهم ما سيسألكم عنه عملاؤكم هنا بخصوص بياناتهم.",
    sections: [
      {
        type: "block", heading: "بناء منتج ليس مثل بناء مشروع",
        paragraphs: [
          "المشروع له عميل واحد. المنتج له عملاء كثر، وكل واحد سيستخدمه بطريقة مختلفة، بمقياس مختلف، ويريد شعاره الخاص عليه.",
          "هذا يغيّر البنية، نموذج التسعير، نموذج الدعم، وخارطة الطريق. بناء SaaS كأنه مشروع هو الخطأ الأكثر تكلفة الذي نراه.",
        ],
      },
      {
        type: "grid", heading: "سبع لبنات لمنصة SaaS",
        items: [
          { title: "بنية SaaS", desc: "متعددة المستأجرين منذ اليوم الأول، ليكون المستأجر رقم 200 ليس بناءً من جديد." },
          { title: "الاشتراكات والفوترة", desc: "خطط، فترات تجريبية، ترقيات، تحصيل — مع مدفوعات محلية." },
          { title: "بوابات المستأجر والإدارة", desc: "خدمة ذاتية حيث يمكن؛ وسوبر أدمن حيث يلزم." },
          { title: "لوحات التحليلات", desc: "تحليلات منتج لكم وتقارير استخدام لمستأجريكم." },
          { title: "واجهات برمجية وتكاملات", desc: "واجهات عامة ليتمكن عملاؤكم من البناء على منصتكم." },
          { title: "الحوسبة السحابية والعمليات التقنية", desc: "نشر آلي، مراقبة، دليل استجابة للحوادث." },
          { title: "علامة تجارية بيضاء", desc: "علامة تجارية لكل مستأجر، نطاقات مخصصة، وعزل للبيانات." },
        ],
      },
      {
        type: "grid", heading: "أنواع SaaS التي نبنيها", columns: 4,
        items: [
          { title: "SaaS عمودي", desc: "لصناعة واحدة بعمق." },
          { title: "أدوات أفقية", desc: "لأي شركة، عبر الصناعات." },
          { title: "داخلي تحوّل لمنتج", desc: "بنيتموه لأنفسكم، والآن تريدون بيعه." },
          { title: "منصات بعلامة بيضاء", desc: "عملاؤكم يعيدون توسيمها وبيعها." },
        ],
      },
      {
        type: "bullets", heading: "ما يأتي كمعيار قياسي",
        items: [
          "عزل المستأجرين",
          "فترات تجريبية",
          "قياس الاستخدام",
          "الفوترة",
          "صلاحيات لكل مستأجر",
          "تدفق الإعداد الأولي",
          "دعم داخل التطبيق",
          "تسجيل دخول إداري كمستخدم",
          "سجل تدقيق",
          "ثنائي اللغة",
        ],
      },
      { type: "callout", text: "لماذا نحن: نحن لا نبني SaaS فحسب، بل نبيعه — Meyar، منصتنا لإدارة المعارض، ونظام إدارة المستودعات هي منتجاتنا الخاصة." },
      { type: "process" },
      {
        type: "faq",
        items: [
          { q: "متعدد المستأجرين أم مستأجر واحد؟", a: "متعدد المستأجرين افتراضيًا لأنه يتوسع ويكلّف أقل في التشغيل. ننتقل إلى نشر مخصص للعملاء المؤسسيين الذين يتطلبون ذلك." },
          { q: "المدفوعات في عُمان؟", a: "نعم — دمجنا معظم بوابات الدفع المحلية ونعرف مطبّاتها. سنشرح لكم ما سيراه عملاؤكم فعليًا على كشف حسابهم." },
          { q: "كم يستغرق MVP؟", a: "من عشرة إلى أربعة عشر أسبوعًا لأول إصدار جاهز للعملاء. نبني البنية للعديد من البداية حتى لو أطلقنا بعميل واحد." },
          { q: "كم يكلّف التشغيل؟", a: "نُنمذج تكلفة الاستضافة لكل مستأجر قبل البناء. ستعرفون هامش الربح الإجمالي على الاشتراك قبل استقبال أول طلب." },
          { q: "هل يمكننا البدء بعميل واحد؟", a: "نعم — ابنوا لواحد، وصمّموا للعديد. الاثنان ليسا نفس مسار الكود." },
          { q: "أين ستكون بيانات المستأجرين؟", a: "نرسم إقامة البيانات معكم مسبقًا. إن سأل عملاؤكم المستهدفون أسئلة صعبة حول مكان بياناتهم، فإن إعادة التصميم لاحقًا هي الأغلى تغييرًا." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "تطوير برمجيات مخصصة", to: "/ar/services/custom-software-development-company-in-oman" },
      { tag: "الخدمات", label: "الحوسبة السحابية والعمليات التقنية", to: "/ar/services/cloud-devops-oman" },
      { tag: "الحلول", label: "منصة تجارة السوق الإلكترونية", to: "/ar/solutions/e-commerce-marketplace" },
    ],
  },

  "mobile-app-development-company-in-oman": {
    slug: "mobile-app-development-company-in-oman",
    navLabel: "تطوير تطبيقات الجوال",
    eyebrow: "الخدمات",
    h1: "تطوير تطبيقات الجوال في عُمان",
    meta: {
      title: "تطوير تطبيقات الجوال في عُمان",
      description: "تطبيقات iOS و Android نبنيها في عُمان. للعملاء، السائقين، الفرق الميدانية، وأدوات داخلية.",
    },
    intro: "تطبيقات iOS و Android نبنيها في عُمان. تطبيقات للعملاء، للسائقين، للفرق الميدانية، وأدوات داخلية — مصممة بالعربية والإنجليزية، مُختبرة على الأجهزة التي يستخدمها المستخدمون فعليًا، بخلفية نبنيها ونديرها بأنفسنا.",
    sections: [
      {
        type: "block", heading: "بنينا تطبيقات تعمل طوال اليوم",
        paragraphs: [
          "يشغّل Twasal Awasal تطبيقين حيّين: تطبيق عملاء عبر أحد عشر نوع خدمة مع محفظة وتتبع مباشر وتسجيل دخول برمز التحقق، وتطبيق سائق مع عروض متتالية، تتبع GPS، وإثبات تسليم بثلاث خطوات — الاسم، الصورة، والتوقيع.",
          "هذه التطبيقات مصممة لتعمل في ظروف حقيقية في عُمان: إشارة ضعيفة، ازدحام مروري، وهواتف أندرويد رخيصة ببطارية محدودة. هذه انضباط مختلف عن بناء عمل عرض تصميم.",
        ],
      },
      {
        type: "grid", heading: "كيف نبني",
        items: [
          { title: "عابر للمنصات أولًا", desc: "React Native / Expo، قاعدة كود واحدة، تكلفة أقل بحوالي 40%. أصلي حين يحتاجه التطبيق فعلًا." },
          { title: "يعمل دون اتصال", desc: "سيفقد السائق الإشارة؛ التطبيق يجب ألا يفقد التسليم." },
          { title: "واعٍ لاستهلاك البطارية", desc: "تتبع GPS لا يستنزف بطارية الهاتف بحلول الظهر." },
          { title: "عربي بشكل حقيقي", desc: "دعم كامل لواجهة اليمين لليسار — لا مجرد شاشة إنجليزية معكوسة." },
          { title: "اختبار على أجهزة حقيقية", desc: "هواتف أندرويد رخيصة، شبكات ضعيفة، وقياس زمن التشغيل البارد." },
          { title: "النشر في المتاجر", desc: "نعرف مطبّات مراجعة كل من Apple و Google." },
        ],
      },
      {
        type: "bullets", heading: "ما يأتي كمعيار قياسي",
        items: [
          "إشعارات فورية",
          "تسجيل دخول برمز التحقق",
          "دعم داخل التطبيق",
          "تحليلات وتقارير أخطاء",
          "قوائم انتظار دون اتصال",
          "روابط عميقة",
          "تقديم للمتاجر",
          "طرح تدريجي",
          "مراقبة ما بعد الإطلاق",
          "قياس البطارية والشبكة",
        ],
      },
      { type: "process" },
      {
        type: "faq",
        items: [
          { q: "iOS و Android من قاعدة كود واحدة؟", a: "نعم، باستخدام React Native / Expo. وحدات أصلية حيث تتطلب ميزة عتاد (LiDAR، البلوتوث الخلفي، أنماط كاميرا محددة) ذلك فعلًا." },
          { q: "كم يكون العابر للمنصات أرخص؟", a: "عادةً 30–40% أرخص من كودين أصليين، وحوالي نصف الصيانة المستمرة. كل ميزة تُطلق مرة واحدة، لا مرتين." },
          { q: "ماذا عن العربية؟", a: "مصممة كلغة أولى، لا شاشة معكوسة. التخطيط، التسلسل الهرمي، الأيقونات، وطول السطر يتغيّر؛ نصمم الاتجاهين معًا منذ البداية." },
          { q: "الإشعارات على iOS؟", a: "APNS عبر خلفيتنا، مع مسار احتياطي عبر إشعارات صامتة للمزامنة الخلفية." },
          { q: "الموافقة في المتاجر؟", a: "نتولى تقديم Apple و Google ونعالج الرفض. كل تطبيق قدمناه صدر." },
          { q: "الدعم المستمر؟", a: "مراقبة ما بعد الإطلاق، تشخيص الأعطال، وتحديثات المتاجر جزء من باقات دعم التطبيقات." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "تطوير برمجيات مخصصة", to: "/ar/services/custom-software-development-company-in-oman" },
      { tag: "الحلول", label: "منصة التوصيل حسب الطلب", to: "/ar/solutions/on-demand-delivery-platform" },
      { tag: "الأعمال", label: "منصة التوصيل والخدمات اللوجستية", to: "/ar/work/delivery-logistics-platform" },
    ],
  },

  "crm-software-development-company-in-oman": {
    slug: "crm-software-development-company-in-oman",
    navLabel: "تطوير أنظمة CRM",
    eyebrow: "الخدمات",
    h1: "تطوير أنظمة CRM في عُمان",
    meta: {
      title: "تطوير أنظمة CRM في عُمان",
      description: "CRM مخصص مبني حول طريقة بيع فريقكم فعليًا. الالتقاط، التأهيل، عرض السعر، المتابعة، الإغلاق، الاحتفاظ، التقرير، الحماية.",
    },
    intro: "نظام CRM لا يعمل إلا إذا طابق طريقة بيع فريقكم فعليًا. معظم الفرق تتخلى عن نظامها لأنه بُني لعملية غير عمليتهم، وكل إدخال يبدو كعبء إداري. نبني نظام CRM الذي يُستخدم فعلًا.",
    sections: [
      {
        type: "grid", heading: "ما نقدّمه",
        items: [
          { title: "تطوير CRM مخصص", desc: "مبني ليطابق عمليتكم." },
          { title: "استشارات CRM", desc: "أحيانًا يكون الجواب تهيئة Zoho بشكل صحيح. سنقول ذلك." },
          { title: "CRM للجوال", desc: "للفرق التي هاتفها هو الواجهة الأساسية." },
          { title: "تكامل CRM", desc: "مع البريد، واتساب، الهاتف، التسويق، والمالية." },
          { title: "ترحيل CRM", desc: "من أنظمة لم تعد تناسبكم — دون فقدان التاريخ." },
          { title: "الدعم والتطوير", desc: "نظام CRM الذي تملكونه بالفعل، يعمل فعليًا." },
        ],
      },
      {
        type: "grid", heading: "أنواع CRM نبنيها", columns: 4,
        items: [
          { title: "قائم على المبيعات", desc: "خط الأنابيب هو كل شيء." },
          { title: "قائم على الخدمة", desc: "المهام، التذاكر، والزيارات المتكررة." },
          { title: "قائم على الميدان", desc: "الهاتف هو الواجهة الأساسية، الحاسوب هو الاستثناء." },
          { title: "قائم على الحسابات", desc: "علاقات B2B كبيرة قليلة حيث المال في التجديد." },
        ],
      },
      {
        type: "stack", heading: "أنظمة CRM قطاعية بنيناها",
        items: ["العقارات", "الرعاية الصحية", "السيارات", "الخدمات اللوجستية", "التعليم", "التجزئة", "الإنشاءات", "الضيافة"],
      },
      {
        type: "block", heading: "الميزات، منظمة حسب ما يحاول مندوب المبيعات فعله",
        subheading: "لا حسب فئة الميزة. هذا الفرق بين CRM يُستخدم و CRM يُتجاهل.",
        items: [
          { title: "الالتقاط", desc: "الاستفسارات من موقعكم، واتساب، الهاتف، وباب المعرض جميعها تصل لقائمة واحدة، موسومة بالمصدر. بعد ثلاثة أشهر ستعرفون أخيرًا أي إنفاق تسويقي يعمل." },
          { title: "التأهيل", desc: "قواعد تقييم تحددونها أنتم، لكيلا يقضي أفضل مندوبيكم صباح الثلاثاء مع من لم يكن سيشتري أبدًا." },
          { title: "عرض السعر", desc: "بناء من قائمة أسعاركم، إرساله، رؤية متى فُتح، وتحويله إلى فاتورة دون إعادة كتابة سطر واحد." },
          { title: "المتابعة", desc: "تسلسلات متابعة تلقائية تعمل بمفردها عبر واتساب والبريد، وتتوقف لحظة رد العميل. هنا تُفقد معظم المبيعات وأرخص شيء يمكن إصلاحه." },
          { title: "الإغلاق", desc: "مراحل تطابق دورة بيعكم الحقيقية، مع توقعات يمكن لمديركم تقديمها لاجتماع مجلس إدارة." },
          { title: "الاحتفاظ", desc: "تواريخ التجديد، تذكيرات الخدمة، وتنبيهات الشراء المتكرر. البيع الثاني يكلف كسرًا من الأول ولا يلاحقه أحد تقريبًا." },
          { title: "التقرير", desc: "حسب المندوب، المنتج، المنطقة، والمصدر، مصدّرًا إلى Excel لحظة يطلب محاسبكم." },
          { title: "الحماية", desc: "تشفير، صلاحيات قائمة على الأدوار، وسجل تدقيق لكل تغيير على كل سجل." },
        ],
        columns: 2,
      },
      { type: "callout", text: "عربي بالكامل — واجهة ثنائية اللغة حقيقية، فلا أحد يعمل في لغته الثانية طوال اليوم." },
      { type: "process" },
      {
        type: "faq",
        items: [
          { q: "مخصص أم مُهيّأ؟", a: "نوصي بصدق حسب عمليتكم. إن كان Zoho أو HubSpot المُهيّأ جيدًا يناسب، سنقول ذلك — وسنُهيّئه لكم إن أردتم." },
          { q: "هل ترحّلون بياناتنا الحالية؟", a: "نعم — بما فيها الملاحظات، المرفقات، والتاريخ الكامل. لا شيء يُترك خلفنا." },
          { q: "تكامل واتساب للأعمال؟", a: "نعم، عبر واجهة WhatsApp Business API. المحادثات، القوالب، وإيصالات التسليم تتدفق إلى السجل." },
          { q: "الجوال؟", a: "كل CRM نبنيه يُطلق مع تطبيق جوال في اليوم الأول. غالبًا ما يكون الواجهة الأكثر استخدامًا." },
          { q: "كم يستغرق؟", a: "CRM مركّز في ستة إلى ثمانية أسابيع. أنظمة CRM متعددة الصناعات والفرق تستغرق من ثلاثة إلى خمسة أشهر." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "تطوير ERP و HRMS", to: "/ar/services/erp-software-development-company-in-oman" },
      { tag: "الخدمات", label: "مختبر الذكاء الاصطناعي", to: "/ar/ai-lab" },
      { tag: "الحلول", label: "منصة إدارة المعارض", to: "/ar/solutions/showroom-management" },
    ],
  },

  "erp-software-development-company-in-oman": {
    slug: "erp-software-development-company-in-oman",
    navLabel: "ERP و HRMS",
    eyebrow: "الخدمات",
    h1: "تطوير أنظمة ERP و HRMS في عُمان",
    meta: {
      title: "تطوير أنظمة ERP و HRMS في عُمان",
      description: "المالية، المخزون، العمليات، والموارد البشرية مترابطة. الممارسة المحلية مبنية داخلها — التعمين، قواعد الإجازات، المستندات العربية، وضريبة القيمة المضافة.",
    },
    intro: "معظم الشركات هنا لا تحتاج نظام ERP عالميًا. تحتاج المالية والمخزون والعمليات والموارد البشرية مترابطة، في نظام يفهم الممارسة المحلية — تقارير التعمين، قواعد الإجازات المحلية، المستندات العربية، وضريبة القيمة المضافة.",
    sections: [
      {
        type: "grid", heading: "وحدات ERP",
        items: [
          { title: "المالية", desc: "دفتر الأستاذ، الذمم المدينة والدائنة، البنوك، جاهز لضريبة القيمة المضافة." },
          { title: "المخزون", desc: "المخزون، الحركات، والتقييم عبر المواقع." },
          { title: "المشتريات", desc: "طلبات، أوامر شراء، موافقات، واستلامات." },
          { title: "المبيعات", desc: "من عروض الأسعار إلى الفواتير في مسار واحد." },
          { title: "العمليات", desc: "الوحدة الخاصة بأعمالكم — سبب التخصيص." },
          { title: "التقارير", desc: "المديرون، المحللون، ومجلس الإدارة يرون الأرقام ذاتها." },
        ],
      },
      { type: "callout", text: "نظام ERP اللوجستي الخاص بنا صُمّم وسُلّم لعميل في أريزونا، الولايات المتحدة." },
      {
        type: "grid", heading: "وحدات HRMS",
        items: [
          { title: "سجلات الموظفين", desc: "المستندات، المعالون، انتهاء الصلاحيات." },
          { title: "الحضور والإجازات", desc: "قواعد الإجازات المحلية، ومعالجة الغياب." },
          { title: "الرواتب", desc: "مكافأة نهاية الخدمة، وملفات جاهزة لنظام WPS." },
          { title: "التوظيف", desc: "الطلب، خط الأنابيب، ورسائل العروض." },
          { title: "الأداء", desc: "الأهداف، المراجعات، والمعايرة." },
          { title: "تنبيهات انتهاء المستندات", desc: "الهويات، الرخص، والتأمينات — لا تنتهي بصمت." },
          { title: "الخدمة الذاتية", desc: "قسائم الدفع، طلبات الإجازة، والتحديثات." },
          { title: "تقارير التعمين", desc: "تُولَّد، لا تُحسب يدويًا." },
        ],
      },
      { type: "process" },
      {
        type: "faq",
        items: [
          { q: "بناء أم شراء؟", a: "اشتروا الأجزاء القياسية، وابنوا الجزء الخاص بكم — غالبًا ما ندمج حزمة محاسبة قياسية مع وحدة عمليات مخصصة. أفضل ERP لمعظم الشركات هو نظام مالي قياسي بالإضافة إلى وحدة مخصصة لما يميّزهم." },
          { q: "كم يستغرق؟", a: "ERP مركّز من ثلاثة إلى خمسة أشهر. النطاق الكامل من ستة إلى اثني عشر شهرًا، يُسلَّم وحدة تلو الأخرى." },
          { q: "التكاملات؟", a: "Tally، Zoho Books، QuickBooks، Odoo، SAP — بالإضافة إلى البنوك، بوابة ضريبة القيمة المضافة، ونظام WPS." },
          { q: "جاهز لضريبة القيمة المضافة؟", a: "نعم — ملتزم بضريبة القيمة المضافة العُمانية، مع التقارير التي تطلبها هيئة الضرائب." },
          { q: "نظام WPS؟", a: "نعم، نُولّد ملفات SIF المتوافقة مع WPS للبنوك." },
          { q: "تقارير التعمين؟", a: "تُحسَب تلقائيًا من سجل الموظف، تُقدَّم شهريًا، وتُصدَّر عندما تطلب الوزارة." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "برمجيات المؤسسات", to: "/ar/services/enterprise-software-development-company-in-oman" },
      { tag: "الحلول", label: "إدارة المستودعات", to: "/ar/solutions/warehouse-management" },
      { tag: "الأعمال", label: "نظام ERP اللوجستي (أريزونا)", to: "/ar/work/logistics-erp" },
    ],
  },

  "application-support-maintenance-oman": {
    slug: "application-support-maintenance-oman",
    navLabel: "دعم وصيانة التطبيقات",
    eyebrow: "الخدمات",
    h1: "دعم وصيانة التطبيقات",
    meta: {
      title: "دعم وصيانة التطبيقات — وفا سوليوشنز",
      description: "دعم وصيانة باتفاقيات خدمة مكتوبة. استلام أنظمة بناها موردون آخرون بعد تدقيق عشرة أيام.",
    },
    intro: "البرمجيات لا تنتهي عند الإطلاق. تنتهي عندما تُغلقونها. المتصفحات تتحدث، المكتبات تحتاج تحديثات أمنية، وعملكم يتغير. البرمجيات التي لا يصونها أحد لا تبقى كما هي — بل تتدهور.",
    sections: [
      {
        type: "grid", heading: "باقاتنا",
        items: [
          { title: "أساسي", desc: "يوم عمل تالٍ. إصلاح أعطال، تحديثات أمنية، مراقبة الجاهزية، والتحقق من النسخ الاحتياطية." },
          { title: "أعمال", desc: "أربع ساعات عمل. تضيف تحسينات صغيرة وتقارير شهرية." },
          { title: "حرج", desc: "ساعة واحدة، على مدار الساعة. تضيف مهندسًا دائمًا على الاستعداد ومراجعة ربع سنوية." },
        ],
      },
      {
        type: "block", heading: "مطوّركم اختفى. الوكالة توقفت عن الرد.",
        paragraphs: [
          "الشخص الذي بنى النظام غادر. نتولى هذه الحالات — بعد نظرة جدية تحت الغطاء، لا بعد مكالمة هاتفية.",
        ],
      },
      {
        type: "numbered", heading: "عملية الاستحواذ لدينا",
        items: [
          "تدقيق لعشرة أيام عمل — الكود، البنية، الأمان، التبعيات، والنشر.",
          "تقرير مكتوب عن جودة الكود، الأمان، والمخاطر.",
          "توصية صادقة: صيانة / إعادة هيكلة / إعادة بناء.",
          "انتقال بسعر ثابت — لا اكتشاف مفتوح النهاية.",
          "ثم الدعم بموجب اتفاقية خدمة مكتوبة.",
        ],
      },
      { type: "callout", text: "أحيانًا يكون الجواب أن النظام سليم ويحتاج فقط من يراقبه." },
      {
        type: "faq",
        items: [
          { q: "هل يجب أن نكون عميل بناء لديكم؟", a: "لا. معظم عملاء الدعم لدينا بنوا أنظمتهم مع فريق آخر. التدقيق مصمم بالضبط لهذه الحالات." },
          { q: "ماذا لو كان الكود غير قابل للإصلاح؟", a: "نقول ذلك، ونُقدِّر تكلفة إعادة البناء مقابل التكلفة السنوية للصيانة. أحيانًا يكون الجواب الصادق هو إعادة البناء؛ أحيانًا هو الاستمرار عامًا آخر." },
          { q: "كم يكلّف التدقيق؟", a: "سعر ثابت. تحصلون على التقرير في الحالتين، سواء استمررتم معنا أو لا." },
          { q: "على مدار الساعة؟", a: "في باقة حرج، نعم — رد خلال ساعة، مهندس دائم على الاستعداد، ومراقبة طوال الساعة." },
          { q: "هل تُرقّعون الثغرات الأمنية؟", a: "نعم — الثغرات المُعلنة على حزمتكم تُراقب وتُرقّع ضمن نافذة اتفاقية الخدمة على كل باقة." },
          { q: "التحسينات أيضًا؟", a: "تحسينات صغيرة مشمولة في باقتي أعمال وحرج. التغييرات الأكبر تُسعّر كمراحل بسعر ثابت." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "الحوسبة السحابية والعمليات التقنية", to: "/ar/services/cloud-devops-oman" },
      { tag: "الخدمات", label: "تطوير برمجيات مخصصة", to: "/ar/services/custom-software-development-company-in-oman" },
      { tag: "Meyar", label: "Meyar Cyber Security GRC", to: "/ar/meyar/cyber-security-grc" },
    ],
  },

  "cloud-devops-oman": {
    slug: "cloud-devops-oman",
    navLabel: "الحوسبة السحابية والعمليات التقنية",
    eyebrow: "الخدمات",
    h1: "الحوسبة السحابية والعمليات التقنية",
    meta: {
      title: "الحوسبة السحابية والعمليات التقنية — وفا سوليوشنز",
      description: "مكان تخزين بياناتكم قرار عمل. نرسمه معكم قبل كتابة الكود — التكلفة، الأداء، وأثر قانون حماية البيانات.",
    },
    intro: "مكان تواجد بياناتكم قرار عمل، لا صدفة. معظم الشركات لا تتخذه بوعي أبدًا — بل يرثنه من اختيار مطوّر سابق قبل سنوات، دون تسجيله. بموجب قانون حماية البيانات، نقل البيانات الشخصية خارج السلطنة يستوجب موافقة وتقييمًا للحماية في الدولة المستقبِلة، وموافقة الوزارة للبيانات الحساسة.",
    sections: [
      {
        type: "grid", heading: "ما نقدّمه",
        items: [
          { title: "استضافة ونشر التطبيقات", desc: "آلي، قابل للتكرار، ومُراقب." },
          { title: "قواعد بيانات مُدارة", desc: "PostgreSQL، MongoDB، Redis — بحجم يناسب الحمل." },
          { title: "تخزين الكائنات", desc: "الملفات، الوسائط، والنسخ الاحتياطية، مع قواعد دورة حياة." },
          { title: "النسخ الاحتياطي واستعادة الكوارث", desc: "مُختبَر، لا مفترض — راجعوا أدناه." },
          { title: "المراقبة والتنبيهات", desc: "لتوقظ المشكلات أحدنا، لا العميل." },
          { title: "العمليات التقنية ونشر مستمر", desc: "كل تغيير يمر عبر نفس خط الأنابيب." },
          { title: "تحصين أمني", desc: "OWASP، رؤوس HTTP مُقواة، وتدوير الأسرار." },
        ],
      },
      { type: "callout", text: "نسخة احتياطية لم يستعدها أحد هي مجرد إشاعة." },
      {
        type: "block", heading: "استشارات إقامة البيانات",
        subheading: "قبل البناء، نرسم معكم:",
        bullets: [
          "ما البيانات الشخصية التي يحتفظ بها النظام وأيها حساس",
          "أي مكوّن يقع أين — التطبيق، قاعدة البيانات، الملفات، النسخ الاحتياطية، السجلات، التحليلات، والأدوات الخارجية",
          "ماذا يعني كل خيار من حيث التكلفة والأداء",
          "ماذا يعني كل خيار بالنسبة لالتزاماتكم بموجب قانون حماية البيانات",
          "ما الذي سيتغيّر إن سأل منظمكم أو أكبر عميل لديكم سؤالًا أصعب لاحقًا",
        ],
      },
      { type: "callout", text: "ثم تقررون، عن وعي." },
      { type: "process" },
      {
        type: "faq",
        items: [
          { q: "هل يمكنكم ترحيلنا؟", a: "نعم — مُخطط، مُتدرَّب عليه، وتنفيذ في وقت يناسب عملكم. نُبدّل DNS يوم أحد صباحًا حتى لا يلاحظ أحد." },
          { q: "دعم نظام لم تبنوه؟", a: "نعم، بعد تدقيق عشرة أيام — راجعوا دعم وصيانة التطبيقات." },
          { q: "ماذا لو تطلب منظمنا معالجة داخل البلاد؟", a: "يصبح ذلك متطلبًا صارمًا في التصميم ونعمل وفقه. أخبرونا في البداية — إعادة توطين البيانات لاحقًا هي من أغلى التغييرات." },
          { q: "أي مزوّدي سحابة؟", a: "AWS، Google Cloud، Azure، Digital Ocean — يُختارون لحمولتكم ومتطلبات إقامتكم، لا لتفضيلاتنا." },
          { q: "كيف تتعاملون مع الأسرار؟", a: "خدمة أسرار مُدارة، مُدوَّرة على جدول، لا تُرفع في الكود أبدًا. الوصول يُدقَّق." },
          { q: "تدريبات استعادة الكوارث؟", a: "استعادة من نسخة احتياطية على الأقل كل 90 يومًا في باقتي أعمال وحرج. نفعل ذلك في بيئة اختبار ونقيسه." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "دعم وصيانة التطبيقات", to: "/ar/services/application-support-maintenance-oman" },
      { tag: "الخدمات", label: "برمجيات المؤسسات", to: "/ar/services/enterprise-software-development-company-in-oman" },
      { tag: "Meyar", label: "Meyar Cyber Security GRC", to: "/ar/meyar/cyber-security-grc" },
    ],
  },

  "digital-marketing-company-in-oman": {
    slug: "digital-marketing-company-in-oman",
    navLabel: "النمو والتسويق الرقمي",
    eyebrow: "الخدمات",
    h1: "النمو والتسويق الرقمي",
    meta: {
      title: "النمو والتسويق الرقمي — وفا سوليوشنز",
      description: "اكتساب يُدار من الفريق الذي يبني منتجكم. نقدّم عملاء محتملين وإيرادات، لا إعجابات.",
    },
    intro: "منتج رائع لا يجده أحد هو هواية. نُدير اكتساب العملاء لنفس العملاء الذين نبني لهم، فمن يكتب إعلاناتكم يفهم ما يفعله منتجكم فعليًا — والصفحة التي نرسل إليها الزيارات يمكننا تعديلها في نفس اليوم.",
    sections: [
      {
        type: "grid", heading: "ما نديره",
        items: [
          { title: "تحسين محركات البحث (SEO)", desc: "تقني، على الصفحة، ومحتوى. أفق ستة أشهر، مشروحًا بصدق." },
          { title: "إعلانات الدفع بالنقرة و Google Ads", desc: "استراتيجية الحملة، بحث الكلمات المفتاحية والجمهور، كتابة الإعلانات، الاختبار، وإدارة الميزانية." },
          { title: "وسائل التواصل الاجتماعي", desc: "محتوى عضوي، حملات مدفوعة، وإدارة المجتمع." },
          { title: "المحتوى", desc: "طويل وقصير، بالعربية والإنجليزية، كتابة بشرية ومحرَّرة." },
        ],
        columns: 4,
      },
      {
        type: "bullets", heading: "ما لن نفعله",
        items: [
          "مقاييس شكلية — نقدّم عملاء محتملين وإيرادات، لا إعجابات",
          "عقود إلزامية طويلة — شهر بشهر بعد الأشهر الثلاثة الأولى",
          "تحسين محركات بحث بأساليب مخالفة — تنجح حتى تُدمّركم",
          "وعود بترتيب مضمون — لا أحد يستطيع ضمان المرتبة الأولى، ومن يعد بذلك يكذب عليكم",
        ],
      },
      { type: "process" },
      {
        type: "faq",
        items: [
          { q: "متى يعمل تحسين محركات البحث؟", a: "ثلاثة إلى ستة أشهر لحركة ذات معنى. من يعد بأسرع يبيع إعلانات ويسميها SEO." },
          { q: "الحد الأدنى لميزانية الإعلانات؟", a: "بيانات مفيدة تبدأ حول 300–500 ريال شهريًا زائد إدارة، حسب صناعتكم وجغرافيتكم." },
          { q: "هل تكتبون المحتوى؟", a: "نعم — بالعربية والإنجليزية، كتّاب بشر مع محرر فوقهم. لا محتوى ذكاء اصطناعي مُعاد صياغته." },
          { q: "التقارير؟", a: "تقرير شهري ومحادثة حقيقية. نُريكم العملاء المحتملين والإيرادات، لا لقطات شاشة من لوحة التحكم." },
          { q: "الالتزام؟", a: "ثلاثة أشهر لإرساء خط الأساس، ثم شهرًا بشهر. إن لم نكن نعمل، لسنا الفريق المناسب." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "تصميم وتطوير الويب", to: "/ar/services/web-design-company-in-oman" },
      { tag: "الخدمات", label: "تطوير CRM", to: "/ar/services/crm-software-development-company-in-oman" },
      { tag: "الخدمات", label: "التصميم والهوية البصرية", to: "/ar/services/ui-ux-design-branding-oman" },
    ],
  },

  "enterprise-software-development-company-in-oman": {
    slug: "enterprise-software-development-company-in-oman",
    navLabel: "برمجيات المؤسسات",
    eyebrow: "الخدمات",
    h1: "تطوير برمجيات المؤسسات في عُمان",
    meta: {
      title: "تطوير برمجيات المؤسسات في عُمان",
      description: "بوابات مؤسسية، محركات موافقات، وطبقات تكامل — مبنية حول المعاملة، لا القسم.",
    },
    intro: "المؤسسات الكبيرة لا تعاني من مشكلة برمجيات. تعاني من مشكلة ترابط — اثنا عشر نظامًا، أربعة أقسام، وكمية كبيرة من إعادة الإدخال اليدوي بينها. نبني المنصات وطبقات التكامل التي تربطها، مع صلاحيات الوصول وسجلات التدقيق والتقارير التي تحتاجها المؤسسة فعليًا.",
    sections: [
      { type: "bullets", heading: "ما يتغيّر في حجم المؤسسات", items: [
        "مستخدمون وأدوار أكثر",
        "أنظمة أكثر يجب أن تعمل معًا",
        "قواعد أكثر — سياسات داخلية وتنظيم خارجي",
        "تدقيق أكثر من الرقابة والمخاطر والمجلس",
        "مخاطر أعلى عند أي خطأ",
      ] },
      { type: "grid", heading: "ما نبنيه", items: [
        { title: "بوابات مؤسسية", desc: "واجهة واحدة عبر أنظمة خلفية متعددة." },
        { title: "وحدات ERP", desc: "حول SAP، Oracle، Odoo، أو Zoho الحالية — لا استبدالها." },
        { title: "محركات موافقات وتدفقات عمل", desc: "مع تفويض، تصعيد، وتدقيق كامل." },
        { title: "التكامل والوسيط", desc: "REST، Webhooks، مزامنة مجدولة، وقوائم انتظار." },
        { title: "مستودعات بيانات وتقارير", desc: "رقم واحد، أينما ظهر." },
        { title: "تحديث الأنظمة القديمة", desc: "التغليف، التمديد، التقاعد — لا انتقال دفعة واحدة." },
      ] },
      { type: "bullets", heading: "أساسيات لا تفاوض عليها في حجم المؤسسة", items: [
        "التحكم بالوصول مع تفويض",
        "سجلات تدقيق غير قابلة للتعديل",
        "موافقات متعددة الخطوات مع تصعيد",
        "تقارير للمديرين، المحللين، والمجلس",
        "تكامل (REST، Webhooks، مزامنة مجدولة، قوائم انتظار)",
        "مراقبة، نسخ احتياطي، واستعادة كوارث مُختبرة",
        "التزامات قانون حماية البيانات مصممة داخل النظام، وأدلة قابلة للتصدير للمدقق",
        "تسجيل دخول موحد مع مزود الهوية لديكم",
      ] },
      {
        type: "numbered", heading: "منهجنا في تحديث الأنظمة القديمة",
        items: [
          "تدقيقه — الكود، نموذج البيانات، التكاملات، والمخاطر.",
          "تغليفه بواجهة برمجية لكيلا يحتاج أي شيء خارجه لمعرفة آلية عمله.",
          "بناء وحدات جديدة بجانبه — يبدأ المستخدمون بالانتقال.",
          "ترحيل البيانات وتدفقات العمل على مراحل.",
          "تقاعد النظام القديم. لا انتقال دفعة واحدة.",
        ],
      },
      { type: "process" },
      {
        type: "faq",
        items: [
          { q: "هل يمكنكم العمل مع نظام ERP الحالي لدينا؟", a: "نعم. نعمل جنبًا إلى جنب مع SAP، Oracle، Odoo، Zoho، والأنظمة المخصصة. نبني الوحدة أو البوابة الخاصة بأعمالكم ونُدمجها مع الحزمة القياسية التي تُشغّل ماليتكم ومخزونكم بالفعل." },
          { q: "هل تتولون إدارة التغيير؟", a: "التدريب والتوثيق نعم. وسنخبركم بصدق أين رأينا التطبيقات تفشل — المشاريع التي تموت ليست تلك ذات البرمجيات السيئة، بل تلك التي لم يخطط فيها أحد للبشر." },
          { q: "كيف تتعاملون مع المراجعة الأمنية؟", a: "نتوقعها. نُقدّم توثيق البنية ومجموعة ضوابط مربوطة بإطاركم. نعمل مع أي شركة متخصصة تستخدمونها لاختبار الاختراق." },
          { q: "تكامل مع أنظمتنا الداخلية؟", a: "نعم — VPN، اتصال خاص، أو عقدة وسيط داخلية حسب شكل شبكتكم." },
          { q: "ماذا عن تسجيل الدخول الموحد؟", a: "Azure AD، Okta، Google Workspace، Keycloak — قياسي. مزودو SAML/OIDC مخصصون عند الطلب." },
          { q: "كيف تُسعّرون أعمال المؤسسات؟", a: "مراحل بسعر ثابت للمراحل المُحدَّدة جيدًا؛ ووقت ومواد للاكتشاف المفتوح فعلًا. نُخبركم أيهما مسبقًا." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "تطوير ERP و HRMS", to: "/ar/services/erp-software-development-company-in-oman" },
      { tag: "الخدمات", label: "الحوسبة السحابية وإقامة البيانات", to: "/ar/services/cloud-devops-oman" },
      { tag: "الأعمال", label: "نظام ERP اللوجستي (أريزونا)", to: "/ar/work/logistics-erp" },
    ],
  },

  "web-design-company-in-oman": {
    slug: "web-design-company-in-oman",
    navLabel: "تصميم وتطوير الويب",
    eyebrow: "الخدمات",
    h1: "تصميم وتطوير المواقع الإلكترونية في عُمان",
    meta: {
      title: "تصميم وتطوير المواقع الإلكترونية في عُمان",
      description: "مواقع مؤسسية، تطبيقات ويب، تجارة إلكترونية، وصفحات هبوط — ثنائية اللغة، سريعة، ومبنية لاجتياز مؤشرات أداء الويب.",
    },
    intro: "الموقع الإلكتروني ليس كتيبًا تعريفيًا. غالبًا ما يكون أول حوار يجريه العميل معكم، ومعظمهم يجريه على الهاتف، عبر بيانات الجوال، بصبر لا يتجاوز ثماني ثوانٍ. نصمم ونبني المواقع وتطبيقات الويب خلف تلك الثواني الثماني.",
    sections: [
      { type: "grid", heading: "ما نبنيه", items: [
        { title: "مواقع مؤسسية", desc: "ثنائية اللغة كافتراض، قابلة للتحرير من فريقكم." },
        { title: "تطبيقات ويب", desc: "بوابات العملاء والأدوات الداخلية." },
        { title: "تجارة إلكترونية", desc: "Shopify، Headless، أو مخصصة بالكامل." },
        { title: "صفحات هبوط", desc: "لحملات يمكن قياسها." },
        { title: "إعادة تصميم", desc: "عندما لم يعد الموقع القديم يمثّل العمل." },
        { title: "ترحيل", desc: "من منصات قديمة، دون كسر تحسين محركات البحث." },
      ] },
      { type: "bullets", heading: "ما يأتي كمعيار قياسي", items: [
        "مؤشرات أداء ويب ممتازة",
        "دعم ثنائي اللغة صحيح مع RTL و hreflang",
        "أساسيات تحسين محركات البحث والبيانات المنظمة",
        "إمكانية الوصول",
        "نظام إدارة محتوى يمكنكم استخدامه فعلًا",
        "GA4 مُهيَّأ بشكل صحيح (خلف الموافقة)",
        "شهادة أمان، رؤوس HTTP مُقواة، ونسخ احتياطي",
        "مراقبة الجاهزية",
      ] },
      { type: "process" },
      {
        type: "faq",
        items: [
          { q: "كم يستغرق؟", a: "موقع مؤسسي من أربعة إلى ستة أسابيع. تجارة إلكترونية من ستة إلى عشرة. تطبيقات ويب المعقدة تستغرق أكثر ونُحدد نطاقها بمراحل." },
          { q: "WordPress أم مخصص؟", a: "نوصي حسب من سيصونه، لا حسب ما نفضّل بناءه. أحيانًا الجواب WordPress؛ وأحيانًا كود Next.js تحت سيطرتكم." },
          { q: "هل تكتبون المحتوى؟", a: "نعم — بالعربية والإنجليزية. نعمل معكم على الرسائل، ثم نُصيغ، نُحرّر، ونُسلّم." },
          { q: "هل سيكون سريعًا في عُمان؟", a: "نقيس من عُمان، لا من الساحل الغربي للولايات المتحدة. المواقع تُعرَض مسبقًا حيث يمكن ويُخدَم من حافة قريبة من مستخدميكم." },
          { q: "هل تتعاملون مع تحسين محركات البحث؟", a: "الأساسيات افتراضيًا. تحسين محركات البحث المستمر ارتباط منفصل — راجعوا النمو والتسويق الرقمي." },
          { q: "إعادة تصميم أم إعادة بناء؟", a: "ننظر في الكود أولًا. أحيانًا التصميم يحتاج عملًا؛ وأحيانًا الموقع الأساسي هو المشكلة. سنقول لكم أيهما بصدق." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "النمو والتسويق الرقمي", to: "/ar/services/digital-marketing-company-in-oman" },
      { tag: "الخدمات", label: "التصميم والهوية البصرية", to: "/ar/services/ui-ux-design-branding-oman" },
      { tag: "الخدمات", label: "دعم وصيانة التطبيقات", to: "/ar/services/application-support-maintenance-oman" },
    ],
  },

  "ui-ux-design-branding-oman": {
    slug: "ui-ux-design-branding-oman",
    navLabel: "التصميم والهوية البصرية",
    eyebrow: "الخدمات",
    h1: "التصميم والهوية البصرية",
    meta: {
      title: "التصميم والهوية البصرية — وفا سوليوشنز",
      description: "تصميم المنتجات والهوية البصرية. العربية تُصمَّم لا تُترجم. نظام تصميم يمكن لمهندسيكم البناء منه فعلًا.",
    },
    intro: "التصميم ليس زخرفة. إنه الفرق بين نظام يستخدمه موظفوكم ونظام يتجنبونه. نصمم منتجات يمد الناس أيديهم إليها، وعلامات تجارية تصمد بعد لحظة مغادرتها لعرض المبيعات.",
    sections: [
      {
        type: "grid", heading: "كيف نصمم برمجيات يستخدمها الناس",
        items: [
          { title: "بحث المستخدمين", desc: "مقابلات ومراقبة — مع مستخدمين حقيقيين في بيئتهم الفعلية." },
          { title: "رسم الرحلة", desc: "المهمة بأكملها، لا الشاشة فقط." },
          { title: "إطارات أولية", desc: "اختبار الفكرة قبل تجميلها." },
          { title: "تصميم عالي الدقة", desc: "شاشات نهائية بالبكسل، في الاتجاهين." },
          { title: "نماذج تفاعلية", desc: "قابلة للنقر، الاختبار، والمشاركة." },
          { title: "أنظمة التصميم", desc: "لتكون الشاشة العشرون متسقة كالأولى." },
          { title: "اختبار قابلية الاستخدام", desc: "مستخدمون حقيقيون، مهام حقيقية، بالوقت." },
        ],
      },
      { type: "callout", text: "العربية تُصمَّم، لا تُترجم. الاتجاه من اليمين لليسار يغيّر التخطيط، التسلسل الهرمي، الأيقونات، وطول السطر. نصمم الاتجاهين معًا منذ البداية." },
      {
        type: "grid", heading: "كيف نبني العلامات التجارية",
        items: [
          { title: "استراتيجية العلامة", desc: "التموقع، الجمهور، الصوت، والوعد." },
          { title: "الشعار والهوية", desc: "علامات تعمل على أيقونة تطبيق وعلى شاحنة." },
          { title: "دليل العلامة", desc: "الألوان، الخطوط، المسافات، والنبرة — قابلة للتطبيق." },
          { title: "المواد المصاحبة", desc: "العروض التقديمية، المقترحات، والقوالب التي يستخدمها فريقكم فعلًا." },
          { title: "الأصول الرقمية", desc: "لكل مكان تظهر فيه العلامة على الإنترنت." },
          { title: "التغليف والطباعة", desc: "حتى كيس شركة التوصيل." },
        ],
      },
      { type: "callout", text: "قيد التطوير: منصة السوق الإلكترونية لدينا لها دليل علامة تجارية كامل يغطي كل شيء من أيقونة التطبيق إلى تغليف التوصيل." },
      { type: "process" },
      {
        type: "faq",
        items: [
          { q: "هل تعملون على العلامة التجارية كما على المنتج؟", a: "نعم — نفس الفريق يتولى الاثنين، فلا يتعارض منتجكم مع علامتكم." },
          { q: "نظام تصميم؟", a: "نعم، في Figma ومرآة في الكود ليبني المهندسون من الرموز، لا من لقطات الشاشة." },
          { q: "هل تجرون بحثًا؟", a: "نعم — مقابلات، مراقبة، واختبار قابلية استخدام. نفضّل اختبار الفكرة قبل بنائها." },
          { q: "الطباعة والتغليف؟", a: "نعم، نتولى إنتاج الطباعة بما فيه التغليف وطلاء المركبات." },
        ],
      },
    ],
    related: [
      { tag: "الخدمات", label: "تصميم وتطوير الويب", to: "/ar/services/web-design-company-in-oman" },
      { tag: "الخدمات", label: "تطوير برمجيات مخصصة", to: "/ar/services/custom-software-development-company-in-oman" },
      { tag: "الخدمات", label: "النمو والتسويق الرقمي", to: "/ar/services/digital-marketing-company-in-oman" },
    ],
  },
};

// AI Lab — /ar/ai-lab (not under /ar/services).
export const AI_LAB_AR = {
  slug: "ai-lab",
  eyebrow: "مختبر الذكاء الاصطناعي",
  h1: "مختبر الذكاء الاصطناعي — ذكاء اصطناعي يصمد في الإنتاج",
  meta: {
    title: "مختبر الذكاء الاصطناعي — ذكاء اصطناعي يصمد في الإنتاج",
    description: "ذكاء اصطناعي مبني ليصل إلى الإنتاج. حدود تكلفة، حلقات تقييم، وإنسان في الحلقة حيث يهم.",
  },
  intro: "معظم مشاريع الذكاء الاصطناعي تموت في مرحلة التجربة. تبدو رائعة في العرض التوضيحي، ثم لا أحد يعرف تكلفة تشغيلها، من يملك الأخطاء، أو كيف تتصل بالنظام الذي يستخدمه العمل فعليًا. نبني ذكاءً اصطناعيًا يصل للإنتاج فعليًا — حلقات تقييم، حدود تكلفة توافقون عليها مسبقًا، إشراف بشري حيث يهم، وتكامل مع الأنظمة التي يستخدمها فريقكم بالفعل.",
  sections: [
    {
      type: "callout", text: "عرض مميز: سباق اكتشاف الذكاء الاصطناعي لأسبوعين — سعر ثابت، أربعة عشر يومًا، من الانطلاق إلى نموذج يعمل. تحصلون على خريطة حالات استخدام مُصنَّفة بالقيمة والجهد، نموذج يعمل على بياناتكم الحقيقية، ونموذج تكلفة لكل ألف استخدام، وعرض سعر ثابت للتنفيذ.",
    },
    {
      type: "grid", heading: "ما نبنيه",
      items: [
        { title: "ذكاء اصطناعي محادثي", desc: "بوتات تفهم العربية، تعرف متى تُحوّل، وتُسجّل كل محادثة." },
        { title: "معالجة المستندات", desc: "الفواتير، أوامر الشراء، النماذج — تُقرأ كما يقرأها شخص." },
        { title: "مساعدون داخل الأنظمة الحالية", desc: "هذا ما تفعله Meyar بالضبط — مساعد على كل بند مخاطرة." },
        { title: "تدفقات عمل ذكية", desc: "بموافقات بشرية لأي شيء يمس المال أو التزامًا قانونيًا." },
        { title: "نماذج تنبؤية", desc: "الاحتفاظ، الطلب، اكتشاف الشذوذ — بحزام ثقة، لا رقم سحري." },
        { title: "ذكاء اصطناعي بالعربية أولًا", desc: "نماذج مختارة ومُقيَّمة على مهام عربية، لا إنجليزية مُعادة تخصيصها." },
      ],
    },
    {
      type: "block", heading: "كيف نحافظ على صدق الذكاء الاصطناعي",
      bullets: [
        "حدود تكلفة مُنمذجة قبل البناء ومُحدَّدة في الكود",
        "حلقات تقييم مُقاسة مقابل مجموعة اختبار حقيقية، لا انطباعات",
        "إنسان في الحلقة لأي شيء يمس المال، السلامة، أو التزامًا قانونيًا",
        "لا صناديق سوداء — كل قرار قابل للتتبع",
        "بياناتكم تبقى لكم، لا تدريب عليها",
      ],
    },
    { type: "process" },
    {
      type: "faq",
      items: [
        { q: "هل نحتاج بياناتنا الخاصة؟", a: "لمعظم حالات الاستخدام، نعم — هذا ما يجعل الذكاء الاصطناعي مفيدًا لعملكم، لا مجرد مساعد عام. نعمل مع البيانات التي لديكم بالفعل." },
        { q: "هل ستدرّب بياناتنا نموذجًا؟", a: "لا. بياناتكم تبقى لكم. نستخدم واجهات مزوّدين حيث تضمن العقود عدم التدريب على بياناتكم، أو نُشغّل نماذج تتحكمون في بيئتها." },
        { q: "أي نماذج؟", a: "أيها يناسب — GPT، Claude، Gemini، مفتوح المصدر. سنقول لكم عندما يقوم نموذج أرخص بالمهمة. اختيار النموذج هندسة، لا ولاء علامة تجارية." },
        { q: "أين يعمل؟", a: "نرسم ذلك معكم قبل البناء — منطقة المزوّد، مستضاف ذاتيًا، أو هجين. راجعوا خدمة الحوسبة السحابية وإقامة البيانات." },
        { q: "ماذا لو لم يكن الذكاء الاصطناعي الجواب الصحيح؟", a: "نقول ذلك في الأسبوع الأول. أحيانًا محرك قواعد مُهيَّأ جيدًا، أو استعلام قاعدة بيانات، هو ما تحتاجونه فعليًا." },
        { q: "التكاليف؟", a: "نُنمذج التكلفة لكل ألف استخدام قبل البناء، ثم نُحدّدها في الكود. لن تُفاجَؤوا بفاتورة استدلال." },
      ],
    },
  ],
  related: [
    { tag: "الخدمات", label: "تطوير برمجيات مخصصة", to: "/ar/services/custom-software-development-company-in-oman" },
    { tag: "الخدمات", label: "تطوير CRM", to: "/ar/services/crm-software-development-company-in-oman" },
    { tag: "Meyar", label: "نظرة عامة على Meyar", to: "/ar/meyar" },
  ],
};
